import {
  FileText,
  CheckCircle,
  ChefHat,
  Truck,
  AlertCircle,
  Clock,
} from 'lucide-react';

export const statusConfig = {
  submitted: { label: 'Submitted', color: 'bg-yellow-100 text-yellow-800', icon: FileText },
  pending_approval: { label: 'Pending Approval', color: 'bg-amber-100 text-amber-800', icon: Clock },
  confirmed: { label: 'Confirmed', color: 'bg-blue-100 text-blue-800', icon: CheckCircle },
  in_production: { label: 'In Production', color: 'bg-purple-100 text-purple-800', icon: ChefHat },
  ready_for_delivery: { label: 'Ready for Delivery', color: 'bg-indigo-100 text-indigo-800', icon: Truck },
  out_for_delivery: { label: 'Out for Delivery', color: 'bg-indigo-100 text-indigo-800', icon: Truck },
  delivered: { label: 'Delivered', color: 'bg-green-100 text-green-800', icon: CheckCircle },
  failed_delivery: { label: 'Failed Delivery', color: 'bg-orange-100 text-orange-800', icon: AlertCircle },
  cancelled: { label: 'Cancelled', color: 'bg-red-100 text-red-800', icon: AlertCircle },
};

// Parse date string safely — date-only strings ("2026-04-10") are UTC midnight in JS,
// which shifts to the previous day in western timezones. Appending T12:00:00 fixes this.
export const safeDate = (d) => {
  if (!d) return null;
  const s = typeof d === 'string' ? d : String(d);
  return new Date(s.length === 10 ? s + 'T12:00:00' : s);
};

// An over-ordering hold is reached by the gate and left by an approval
// decision — never by picking it out of a status dropdown.
export const GATED_STATUS = 'pending_approval';

export const SETTABLE_STATUS_ENTRIES = Object.entries(statusConfig)
  .filter(([key]) => key !== GATED_STATUS);

// Statuses that block editing — one definition, shared with every portal.
export { NON_EDITABLE_STATUSES } from '../../../lib/orderEditPolicy';
